(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password-protection"] && !window.DesignMode) return;
  try {
    
  class PasswordProtection {
    constructor() {
      this.modal = document.getElementById('password-protection-modal');
      this.form = document.getElementById('password-protection-form');
      this.input = document.getElementById('password-input');
      this.error = document.getElementById('password-error');
      this.message = document.getElementById('password-modal-message');
      this.submitBtn = this.form?.querySelector('.password-modal__submit');
      this.closeBtn = this.modal?.querySelector('.password-modal__close');
      
      this.currentContext = null;
      this.sessionDuration = 24 * 60 * 60 * 1000; // Always 24 hours in milliseconds
      this.rememberPassword = true; // Always remember passwords
      
      this.init();
    }

    init() {
      if (!this.modal || !this.form) return;
      
      // Event listeners
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.closeBtn?.addEventListener('click', this.hideModal.bind(this));
      this.modal.addEventListener('click', this.handleOverlayClick.bind(this));
      
      // ESC key to close modal
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isVisible()) {
          this.hideModal();
        }
      });
    }

    showModal(context = {}) {
      this.currentContext = context;
      
      // Update modal content based on context
      if (context.message) {
        this.message.textContent = context.message;
      }
      
      // Clear previous state
      this.hideError();
      this.input.value = '';
      
      // Show modal
      this.modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      // Focus input
      setTimeout(() => {
        this.input.focus();
      }, 100);
    }

    hideModal() {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      this.currentContext = null;
    }

    isVisible() {
      return this.modal.style.display === 'flex';
    }

    handleOverlayClick(e) {
      if (e.target === this.modal.querySelector('.password-modal__overlay')) {
        this.hideModal();
      }
    }

    async handleSubmit(e) {
      e.preventDefault();
      
      const password = this.input.value.trim();
      if (!password) return;
      
      this.setLoading(true);
      this.hideError();
      
      try {
        const isValid = await this.validatePassword(password);
        
        if (isValid) {
          this.onPasswordSuccess(password);
        } else {
          this.showError();
          this.input.select();
        }
      } catch (error) {
        console.error('Password validation error:', error);
        this.showError();
      } finally {
        this.setLoading(false);
      }
    }

    async validatePassword(password) {
      const context = this.currentContext || {};
      
      // Check against different password types based on context
      if (context.type === 'store') {
        return password === (window.passwordProtectionSettings?.storePassword || '');
      } else if (context.type === 'product') {
        // Check product-specific password first, then default
        const productPassword = context.productPassword || window.passwordProtectionSettings?.productPassword || '';
        return password === productPassword;

      }
      
      return false;
    }

    onPasswordSuccess(password) {
      const context = this.currentContext || {};
      
      console.log('[VIP] Password success - storing session', {
        type: context.type,
        id: context.id,
        rememberPassword: this.rememberPassword,
        sessionDuration: this.sessionDuration
      });
      
      // Store password in session (always enabled)
      if (context.type && context.id) {
        const storageKey = `password_${context.type}_${context.id}`;
        const storageData = {
          password: password,
          timestamp: Date.now(),
          expires: Date.now() + this.sessionDuration
        };
        
        console.log('[VIP] Storing session data:', { storageKey, storageData });
        
        // Persist to localStorage/sessionStorage
        try { 
          localStorage.setItem(storageKey, JSON.stringify(storageData));
          console.log('[VIP] Stored in localStorage');
        } catch (e) {
          console.error('[VIP] localStorage error:', e);
        }
        
        try { 
          sessionStorage.setItem(storageKey, JSON.stringify(storageData));
          console.log('[VIP] Stored in sessionStorage');
        } catch (e) {
          console.error('[VIP] sessionStorage error:', e);
        }
        
        // Also set a cookie for reliability across early script loads
        try {
          const maxAge = Math.floor(this.sessionDuration / 1000);
          const cookieValue = `${storageKey}=1; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
          document.cookie = cookieValue;
          console.log('[VIP] Cookie set:', cookieValue);
        } catch (e) {
          console.error('[VIP] Cookie error:', e);
        }
      } else {
        console.log('[VIP] Session storage disabled or missing context');
      }
      
      // Hide modal
      this.hideModal();
      
      // Execute success callback
      if (context.onSuccess && typeof context.onSuccess === 'function') {
        context.onSuccess();
      } else {
        // For store-wide protection, reload the page
        if (context.type === 'store') {
          console.log('[VIP] Store unlock - reloading page');
          window.location.reload();
        } else {
          console.log('[VIP] Product unlock - no reload needed');
          // For products, just re-init galleries without reload
          this.reinitializeGalleries();
        }
      }
    }

    showProtectedContent(context) {
      // Show protected content based on context
      if (context.contentSelector) {
        const content = document.querySelector(context.contentSelector);
        if (content) {
          content.style.display = '';
        }

        // Remove the temporary style tag that hid the content
        const styleElId = `password-hide-style-${context.type}-${context.id}`;
        const styleEl = document.getElementById(styleElId);
        if (styleEl && styleEl.parentNode) {
          styleEl.parentNode.removeChild(styleEl);
        }
        // Trigger reflow to ensure galleries/main image render after being unhidden
        try {
          if (window.lazySizes && window.lazySizes.autoSizer) {
            window.lazySizes.autoSizer.checkElems();
          } else {
            window.dispatchEvent(new Event('resize'));
          }
        } catch (_) {}
      }
      
      // Hide password protection overlay
      if (context.overlaySelector) {
        const overlay = document.querySelector(context.overlaySelector);
        if (overlay) {
          overlay.style.display = 'none';
        }
      }
    }

    setLoading(loading) {
      if (loading) {
        this.submitBtn.classList.add('loading');
        this.submitBtn.disabled = true;
      } else {
        this.submitBtn.classList.remove('loading');
        this.submitBtn.disabled = false;
      }
    }

    showError() {
      this.error.style.display = 'block';
    }

    hideError() {
      this.error.style.display = 'none';
    }

    // Check if password is already stored with expiration (cookie/localStorage/sessionStorage)
    isPasswordStored(type, id) {
      console.log('[VIP] Checking password storage', { type, id, rememberPassword: true });
      
      const storageKey = `password_${type}_${id}`;
      console.log('[VIP] Storage key:', storageKey);
      
      // 1) Cookie check
      try {
        const cookieMatch = document.cookie.match(new RegExp(`(?:^|; )${storageKey}=([^;]*)`));
        console.log('[VIP] Cookie check:', { found: !!cookieMatch, value: cookieMatch?.[1] });
        if (cookieMatch) {
          console.log('[VIP] Valid cookie found');
          return true;
        }
      } catch (e) {
        console.error('[VIP] Cookie check error:', e);
      }
      
      // 2) Storage check with expiry
      let raw = null;
      try { 
        raw = localStorage.getItem(storageKey) || sessionStorage.getItem(storageKey);
        console.log('[VIP] Storage raw data:', raw);
      } catch (e) {
        console.error('[VIP] Storage access error:', e);
      }
      
      if (raw) {
        try {
          const data = JSON.parse(raw);
          console.log('[VIP] Parsed storage data:', data);
          
          if (data && data.expires > Date.now()) {
            console.log('[VIP] Valid storage data found (not expired)');
            return true;
          } else {
            console.log('[VIP] Storage data expired, cleaning up');
          }
        } catch (e) {
          console.error('[VIP] Storage parse error:', e);
        }
      }
      
      // Clean up expired data
      try { localStorage.removeItem(storageKey); } catch (_) {}
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      
      console.log('[VIP] No valid password storage found');
      return false;
    }

    // Re-initialize galleries after unlock
    reinitializeGalleries() {
      try {
        console.log('[VIP] Reinitializing galleries');
        
        // Force reflow first
        document.body.offsetHeight;
        
        // Re-init slick carousel
        const gallery = document.querySelector('.product-slideshow');
        if (gallery && window.jQuery && window.jQuery(gallery).slick) {
          window.jQuery(gallery).slick('setPosition');
          window.jQuery(gallery).slick('refresh');
          console.log('[VIP] Slick carousel refreshed');
        }
        
        // Force lazy loading check
        if (window.lazySizes) {
          if (window.lazySizes.autoSizer) {
            window.lazySizes.autoSizer.checkElems();
          }
          if (typeof window.lazySizes.unveilall === 'function') {
            window.lazySizes.unveilall();
          }
        }
        
        // Final reflow trigger
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 100);
      } catch (e) {
        console.error('[VIP] Gallery re-init error:', e);
      }
    }

    // Public method to check and show password modal if needed
    checkAccess(type, id, options = {}) {
      // Check if password is already stored
      if (this.isPasswordStored(type, id)) {
        if (options.onSuccess) options.onSuccess();
        return true;
      }
      
      // Show password modal
      this.showModal({
        type: type,
        id: id,
        ...options
      });
      
      return false;
    }
  }

  // Initialize password protection when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    window.passwordProtection = new PasswordProtection();
  });

  // Global function to show password modal (called from snippets)
  window.showPasswordModal = function(type, id, message, customPassword, contentSelector, overlaySelector) {
    if (!window.passwordProtection) {
      console.error('Password protection not initialized');
      return;
    }

    const options = {
      message: message,
      productPassword: customPassword,
      onSuccess: function() {
        console.log('[VIP] Global showPasswordModal success callback', {
          type, id, contentSelector, overlaySelector
        });
        
        // Show success message briefly
        const successEl = document.getElementById('password-success');
        if (successEl) {
          successEl.style.display = 'block';
          console.log('[VIP] Success message shown');
          setTimeout(() => {
            successEl.style.display = 'none';
            console.log('[VIP] Success message hidden');
          }, 2000);
        }

        // Show protected content
        if (contentSelector) {
          const contentElements = document.querySelectorAll(contentSelector);
          console.log('[VIP] Content elements found:', contentElements.length);
          contentElements.forEach(el => {
            el.style.display = '';
            el.style.removeProperty('display');
            console.log('[VIP] Content element shown:', el);
          });

          // Also remove any CSS hide tag added for this protection
          const styleElId = `password-hide-style-${type}-${id}`;
          const styleEl = document.getElementById(styleElId);
          if (styleEl && styleEl.parentNode) {
            styleEl.parentNode.removeChild(styleEl);
            console.log('[VIP] Hide style removed:', styleElId);
          }
        }

        // Hide/remove protection overlay
        if (overlaySelector) {
          const overlayElements = document.querySelectorAll(overlaySelector);
          console.log('[VIP] Overlay elements found:', overlayElements.length);
          overlayElements.forEach(el => {
            if (el && el.parentNode) {
              el.parentNode.removeChild(el);
              console.log('[VIP] Overlay element removed:', el);
            }
          });
        }
        
        // Re-initialize galleries without page reload
        try {
          console.log('[VIP] Re-initializing galleries after unlock');
          
          // Force reflow first
          document.body.offsetHeight;
          
          // Re-init slick carousel
          const gallery = document.querySelector('.product-slideshow');
          if (gallery && window.jQuery && window.jQuery(gallery).slick) {
            window.jQuery(gallery).slick('setPosition');
            window.jQuery(gallery).slick('refresh');
            console.log('[VIP] Slick carousel refreshed');
          }
          
          // Force lazy loading check
          if (window.lazySizes) {
            if (window.lazySizes.autoSizer) {
              window.lazySizes.autoSizer.checkElems();
            }
            // Check if unveilall method exists before calling
            if (typeof window.lazySizes.unveilall === 'function') {
              window.lazySizes.unveilall();
              console.log('[VIP] LazySizes unveilall triggered');
            } else {
              console.log('[VIP] LazySizes unveilall not available, using alternative');
              // Alternative: trigger resize to force lazy loading
              window.dispatchEvent(new Event('resize'));
            }
          }
          
          // Final reflow trigger
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            console.log('[VIP] Final resize event triggered');
          }, 100);
        } catch (e) {
          console.error('[VIP] Gallery re-init error:', e);
        }
        
        console.log('[VIP] Success callback completed without page reload');
      }
    };

    window.passwordProtection.checkAccess(type, id, options);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
